<template>
  <div v-if="dbuser" class="container mt-4">
    <h3>{{ $t('message.myCards') }}</h3>
    <div>
      <ul v-if="this.savedCards.length" class="list-unstyled card-list">
        <li
          v-for="(card, index) of this.savedCards"
          :key="index"
          class="d-flex justify-content-between py-2"
        >
          <div class="payment-card" v-if="card.ElidedPan">
            <span :class="card.CardType | cardName">{{ card.ElidedPan | formatCard }}</span>
          </div>
          <div>
            <a
              href="#"
              class="text-danger fw-600"
              @click.prevent="selectCard(card.CardIdentifier)"
            >{{ $t('message.remove') }}</a>
          </div>
        </li>
      </ul>
      <a href="#" class=" fw-600" :class="isSushi ? 'color-sushi curved-5' : 'text-primary'" @click.prevent="fncShowModal()">
        <span class="material-icons float-left" >add</span>
        {{ $t('message.addACard') }}
      </a>
    </div>
    <modal v-if="showModal" ref="addModal" @close="closeModal">
      <template slot="header">
        <h5 class="modal-title">{{ $t('message.storeCard') }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <template slot="body">
        <div class="pl-2 pr-2">
          <card-component ref="cardInfo" :edit-model="editModel" />
          <div v-show="error" class="w-100 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="w-100 d-flex justify-content-between mb-2">
          <button
            type="button"
            class="btn btn-lg btn-cancel"
            @click="error=''"
            data-dismiss="modal"
          >{{ $t('message.cancel') }}</button>
          <button
            :disabled="loading"
            type="button"
            class="btn btn-lg btn-primary w-75 d-flex justify-content-between shadow"
            @click="addCard"
            :style="mobileStyles.btn"
          >
            {{ $t('message.addCard') }}
            <span v-show="loading">
              <i class="spin ml-4" />
            </span>
          </button>
        </div>
      </template>
    </modal>
    <confirm
      v-if="showConfirm"
      ref="deleteConfirm"
      :proccessing="deleting"
      @confirmed="deleteCard"
      @close="closeConfirm"
    >
      <template slot="body">
        <p>{{ $t('message.areYouSureDeleteCard') }}</p>
        <div v-show="cardError" class="w-100 mt-4">
          <div class="alert alert-danger" role="alert">
            <strong>{{ cardError }}</strong>
          </div>
        </div>
      </template>
    </confirm>
  </div>
</template>

<script>
import modal from "./../modal";
import confirm from "../confirm";
import shared from "../../sharedscripts/user/cards.js";
import CardComponent from "../shared/CardComponent";
import { mapGetters } from "vuex";
export default {
  components: {
    modal,
    confirm,
    CardComponent
  },
  filters: {
    ...shared.filters
  },
  props: {
    dbuser: {
      type: Object,
      default: () => {}
    },
    isSushi :{
      type : Boolean,
      default : false
    }
  },

  data() {
    return {
      showModal: false,
      showConfirm: false,
      editModel: {
        CardNumber: "",
        CVV: "",
        ExpireDate: ""
      },
      cardType: "master",
      loading: false,
      error: "",
      selectedCard: "",
      deleting: false,
      cardError: "",
      savedCards: [],
    };
  },
  mounted() {
    shared.mounted(this);
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["mobileStyles"])
  },
  methods: {
    ...shared.methods
  }
};
</script>
